<div
  class="transaction-list-item-content flex h-full min-w-0 flex-1 flex-col justify-center py-2 pr-4"
  [class.cursor-pointer]="interactive()"
  [class.no-account]="!effectivePlaidAccount(transaction())"
  [attr.role]="interactive() ? 'button' : null"
  [attr.tabindex]="interactive() ? 0 : null"
  data-testid="transaction-row-content"
  (click)="requestEdit()"
  (keydown.enter)="requestEdit()"
  (keydown.space)="$event.preventDefault(); requestEdit()"
>
  <div class="grid min-w-0 grid-cols-transaction-row gap-x-2 gap-y-0.5">
    <div class="flex min-w-0 items-center gap-2">
      <span class="min-w-0 flex-1 truncate text-body-sm font-semibold leading-tight text-text-title">
        {{ merchantDisplayName(transaction()) }}
      </span>

      @if (effectiveBankMeta(transaction())?.pending) {
        <span class="shrink-0 text-text-muted" aria-label="Pending" title="Pending">
          <ng-icon hlm name="lucideClock" size="14" />
        </span>
      }
    </div>

    <span
      class="shrink-0 text-right text-body-sm font-semibold leading-tight tabular-nums"
      [class.text-brand-primary-strong]="isIncome(transaction())"
      [class.text-text-title]="!isIncome(transaction())"
    >
      {{ isIncome(transaction()) ? '+' : '' }}{{ transaction().amount | currency }}
    </span>

    <div
      class="transaction-list-item-bucket flex min-w-0 w-full items-center"
      [class.col-span-2]="!effectivePlaidAccount(transaction())"
    >
      @if (showBucketSelector() && interactive()) {
        <!-- Host sizes to the combobox plus save slot so row-clicks still work in
             the leftover cell. The combobox keeps its width when the check shows, unless the
             row is too narrow for both (small phones). -->
        <bucket-selector
          [fillWidth]="true"
          [transaction]="transaction()"
          [buckets]="buckets()"
          [selectedBucket]="selectedBucket()"
          [needsSaving]="needsSaving()"
          [createdBucketTarget]="createdBucketTarget()"
          (changeSelectedBucket)="changeSelectedBucket($event)"
          (saveBucket)="onSaveBucket($event)"
          (click)="$event.stopPropagation()"
          (keydown.enter)="$event.stopPropagation()"
          (keydown.space)="$event.stopPropagation()"
        />
        @if (suggestedRule(); as suggestedRule) {
          <button
            type="button"
            class="transaction-list-item-rule-chip ml-1.5 inline-flex h-[26px] w-[26px] shrink-0 items-center justify-center self-center rounded-full border border-brand-primary/30 bg-surface-tint text-brand-primary-strong hover:bg-brand-primary/15"
            data-testid="transaction-rule-suggestion-chip"
            [attr.aria-label]="'Review suggested rule: sort ' + suggestedRule.merchant + ' automatically'"
            title="Suggested rule"
            (click)="openSuggestedRule($event)"
            (keydown.enter)="$event.stopPropagation()"
            (keydown.space)="$event.stopPropagation()"
          >
            <app-ui-icon class="h-3.5 w-3.5" name="list" />
          </button>
        }
      } @else if (assignedBucket(); as bucket) {
        <span class="block min-w-0 truncate text-body-sm leading-tight text-text-muted">
          {{ bucket.name }}
        </span>
      }
    </div>

    @if (effectivePlaidAccount(transaction()); as plaidAccount) {
      <span
        class="transaction-list-item-account inline-flex min-w-0 items-center justify-end gap-1.5 truncate text-right text-label-sm leading-tight text-text-muted opacity-80"
      >
        <span class="truncate">{{ accountDisplayName(plaidAccount) }}</span>
        @if (institutionLogoSrc(plaidAccount); as logoSrc) {
          @if (!logoFailed(logoSrc)) {
            <img
              class="h-3.5 w-3.5 shrink-0 rounded-sm object-contain"
              [src]="logoSrc"
              [alt]="plaidAccount.institution?.name ? plaidAccount.institution?.name + ' logo' : 'Institution logo'"
              loading="lazy"
              (error)="onLogoError(logoSrc)"
            />
          }
        }
      </span>
    }
    @if (!transaction().deleted && !transaction().parent?.deleted && (transaction().splitMismatch ?? transaction().parent?.splitMismatch); as mismatch) {
      <span class="col-span-2 truncate text-label-sm leading-tight text-text-muted" data-testid="split-mismatch-warning"
        [attr.title]="'Your splits are ' + ((mismatch.remaining < 0 ? -mismatch.remaining : mismatch.remaining) | currency) + ' off from the bank amount. Edit splits to fix.'">
        Splits {{ (mismatch.remaining < 0 ? -mismatch.remaining : mismatch.remaining) | currency }} off.
        @if (interactive()) { <span class="text-brand-primary-strong underline">Edit splits to fix.</span> }
      </span>
    }
  </div>
</div>
